import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { DialogRef } from '@ngneat/dialog';

import { isMobileView } from '@core/utils';
import { NewsType, SectionType, TaskType, Visibility } from '@core/enums';
import { NewsComposition } from '@shared/compositions';
import { ButtonComponent, DropdownComponent, IconComponent, ImageSelectorComponent } from '@shared/components/ui';
import { FormErrorComponent } from '@shared/components';

@Component({
  selector: 'app-news-form',
  imports: [CommonModule, ButtonComponent, IconComponent, DropdownComponent, FormErrorComponent, FormsModule, NgSelectModule, ReactiveFormsModule, TranslateModule, ImageSelectorComponent],
  templateUrl: './news-form.component.html',
  styleUrls: ['./news-form.component.scss'],
})
export class NewsFormComponent extends NewsComposition implements OnInit {
  protected readonly isMobileView = isMobileView;
  protected readonly EventVisibility = Visibility;
  protected readonly TasksType = TaskType;
  protected readonly EventTaskType = TaskType;
  protected readonly NewsType = NewsType;
  protected readonly SectionType = SectionType;
  protected groupId = null;
  private readonly _route = inject(ActivatedRoute);
  private readonly _dialogRef: DialogRef;

  constructor() {
    super();
    if (!isMobileView()) {
      this._dialogRef = inject(DialogRef);
    }
  }

  get shouldLockGroupDropdown(): boolean {
    return this.groupId;
  }

  get isUpdateMode(): boolean {
    return !!(this.currentNews && this.currentNews.id && this.currentNews?.imageUrl);
  }

  ngOnInit() {
    this._initDataForForm();
    this._fetchTeamUsersAndGroups();
    if (!isMobileView() && this._dialogRef?.data) {
      const { news, groupId } = this._dialogRef.data;
      if (news) {
        this.currentNews = news;
      }
      if (groupId) {
        this.groupId = Number(groupId);
        this.form.patchValue({ audience: NewsType.Group });
        this.form.get('audience')?.disable();

        const groupCheckInterval = setInterval(() => {
          if (this.groups && this.groups.length > 0) {
            clearInterval(groupCheckInterval);
            this.form.patchValue({ groups: this.groupId });
            this.form.get('groups')?.disable();
          }
        }, 100);
      }
    } else if (isMobileView() && this._bottomSheetService?.currentSheetData) {
      const { news, groupId } = this._bottomSheetService.currentSheetData;
      if (news) {
        this.currentNews = news;
      }
      if (groupId) {
        const groupId = this._bottomSheetService.currentSheetData.groupId;
        this.groupId = Number(groupId);
        this.form.patchValue({ audience: NewsType.Group });
        this.form.get('audience')?.disable();

        const groupCheckInterval = setInterval(() => {
          if (this.groups && this.groups.length > 0) {
            clearInterval(groupCheckInterval);
            this.form.patchValue({ groups: this.groupId });
            this.form.get('groups')?.disable();
          }
        }, 100);
      }
    }

    if (this.currentNews && this.currentNews.id) {
      this._fetchNewsById(this.currentNews.id, true);
    }
  }
}
